import type { Theme } from '@bond/components'
import { getTldFromUrl } from './getTldFromUrl'

const THEME = 'theme'

export function getTheme() {
  return document.cookie
    .split(';')
    .find((cookie) => cookie.startsWith(`${THEME}=`))
    ?.split('=')[1] as Theme | undefined
}

export function setTheme(theme: Theme) {
  document.cookie = `${THEME}=${theme}; expires=${new Date(new Date().setFullYear(new Date().getFullYear() + 10))}; path=/${window.location.hostname !== 'localhost' ? `; domain=.${getTldFromUrl(new URL(window.location.href))}` : ''}`
}
